var MULTIPLIER = 4;
export var spacing = {
  'spacing-0': {
    value: "".concat(MULTIPLIER * 0, "px")
  },
  'spacing-05': {
    value: "".concat(MULTIPLIER * 0.5, "px")
  },
  'spacing-1': {
    value: "".concat(MULTIPLIER * 1, "px")
  },
  'spacing-2': {
    value: "".concat(MULTIPLIER * 2, "px")
  },
  'spacing-3': {
    value: "".concat(MULTIPLIER * 3, "px")
  },
  'spacing-4': {
    value: "".concat(MULTIPLIER * 4, "px")
  },
  'spacing-5': {
    value: "".concat(MULTIPLIER * 5, "px")
  },
  'spacing-6': {
    value: "".concat(MULTIPLIER * 6, "px")
  },
  'spacing-7': {
    value: "".concat(MULTIPLIER * 7, "px")
  },
  'spacing-8': {
    value: "".concat(MULTIPLIER * 8, "px")
  },
  'spacing-12': {
    value: "".concat(MULTIPLIER * 12, "px")
  },
  'spacing-16': {
    value: "".concat(MULTIPLIER * 16, "px")
  },
  'spacing-20': {
    value: "".concat(MULTIPLIER * 20, "px")
  },
  'spacing-24': {
    value: "".concat(MULTIPLIER * 24, "px")
  },
  'spacing-28': {
    value: "".concat(MULTIPLIER * 28, "px")
  },
  'spacing-32': {
    value: "".concat(MULTIPLIER * 32, "px")
  }
};